import {
  Box,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

// COMPONENTS
import Loader from '../../../common/Loader';

// NETWORK
import useCarrierRequest from '../../../../requests/CarrierRequest';

const CarrierDeviceList = ({ device, onShow, onNew, errorHandler }) => {
  const [loading, setLoading] = useState(true);
  const [carrierDevices, setCarrierDevices] = useState([]);
  const { getDeviceCarrierDevices } = useCarrierRequest();

  useEffect(() => {
    if (!device.device_id) return;

    const fetchCarrierDevices = async () => {
      setLoading(true);
      const carrierDevices = await getDeviceCarrierDevices(
        device.device_id,
        errorHandler
      );
      setCarrierDevices(carrierDevices);
      setLoading(false);
    };
    fetchCarrierDevices();
  }, [device]);

  const generateTable = () => {
    if (loading) return <Loader />;

    if (carrierDevices.length === 0) {
      return <Typography gutterBottom>No Carrier Devices</Typography>;
    }

    return (
      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Carrier</TableCell>
              <TableCell>Provider</TableCell>
              <TableCell>Priority</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {carrierDevices.map((device) => (
              <TableRow
                key={device.carrier_device_id}
                id={`device-${device.carrier_device_id}`}
              >
                <TableCell name="name">
                  <Link tabIndex={0} onClick={() => onShow(device)}>
                    {device.carrier_name}
                  </Link>
                </TableCell>
                <TableCell>{device.provider_name}</TableCell>
                <TableCell className="column-right">
                  {device.priority}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 2,
        }}
      >
        <Typography variant="h4">List of Carrier Devices</Typography>
        <Button variant="contained" color="secondary" onClick={onNew}>
          Add New
        </Button>
      </Box>
      {generateTable()}
    </Box>
  );
};

export default CarrierDeviceList;
